import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/Navbar/ProductsNavbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/products/BackButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/products/Controls.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/products/ProductCard.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
